"use client";

import { Statistics } from "@/components/statisctics/Statistics";
import { TaskManager } from "@/components/taskManager/TaskManager";
import { TopToolBar } from "@/components/topToolBar";
import { Footer } from '@/components/footer';
import Timer from "@/components/timer";
import { useTaskStore } from "@/stores/TaskStore";
import TaskDetailPanel from "@/components/taskManager/taskDetail/TaskDetailPanel";
import { useTaskDetailStore } from "@/stores/TaskDetailStore";
import { motion, AnimatePresence } from "framer-motion";

export default function Home() {
  const { getCompletedTasksCount, getTotalTasks } = useTaskStore();
  const { taskId } = useTaskDetailStore();

  return (
    <main>
      <div className="w-full min-h-screen flex items-center justify-center">
        <div className="w-full p-10 col-span-2 flex flex-col items-center justify-center space-y-8">
          <TopToolBar />
          <div className="w-full flex flex-col md:flex-row items-stretch justify-center md:space-y-0">
            <div className="flex flex-col items-center justify-center space-y-8 w-full md:w-1/2 lg:max-w-md">
              <Timer />
              <Statistics
                weeklyTotal={getCompletedTasksCount()}
                taskHistory={getTotalTasks()}
              />
            </div>

            <div className="w-full md:w-3/4 flex-1 lg:max-w-xl flex flex-row space-x-4">
              <AnimatePresence mode="wait">
                {!taskId ? (
                  <motion.div
                    key="taskManager"
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -20 }}
                    transition={{ duration: 0.3 }}
                    className="w-full flex-grow"
                  >
                    <TaskManager />
                  </motion.div>
                ) : (
                  <motion.div
                    key="taskDetailPanel"
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: 20 }}
                    transition={{ duration: 0.3 }}
                    className="w-full flex-grow"
                  >
                    <TaskDetailPanel />
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </div>
          <div className="w-full max-w-7xl mx-auto">
            <Footer />
          </div>
        </div>
      </div>
    </main>
  );
}